import { market } from '../../constants';
import { parseIdWithHyphen } from '../tickets/SelfService';
import moment from 'moment';
/* According to the market return true if show tickets 
  or false if show contact form
*/
export const showTicketsOrForm = () => market !== 'pe';

export const setPhoneNumber = (profile) => {
  if (profile.phone1) return profile.phone1;
  if (profile.mobilePhone1) return `9${profile.mobilePhone1}`;
};

export const bodyTicketProductGenerator = ({
  profile,
  type,
  motiveId,
  product,
  comment,
}) => ({
  ...bodyIssueTicketGenerator({ profile, type, motiveId, comment }),
  oc: product.isMkp ? product.dispatch.dispatch_id : product.orderId,
  sku: product.dispatch.lines[0].product_sku || product.sku,
  cud: product.dispatch.dispatch_id,
  valor: product.price,
  tipo_trans: product.source,
  fecha_compra: moment(product.purchaseDate, 'YYYY-MM-DD HH:mm:ss.S').format(
    'YYYY-MM-DD',
  ),
});

export const bodyIssueTicketGenerator = ({
  profile,
  type,
  motiveId,
  comment,
  phone,
}) => ({
  rut: parseIdWithHyphen(profile.logonId).toLowerCase(),
  nombre_cli: `${profile.firstName} ${profile.lastName}`,
  tipo: type,
  motivo: motiveId,
  telefono: phone || setPhoneNumber(profile),
  correo: profile.email1,
  comentario: comment,
  mi_cuenta: 'si',
});
